import axios from 'axios'

export default {
  async getAddressInputDescriptionHtml(token) {
    const response = await axios.get(
      `/api/v1/pickup/gift_card_tickets/${token}`
    )
    return response.data.data.attributes.address_input_description_html
  }
}
